import { useEffect } from 'react';
import type { SurrenderRootResponse } from 'src/apis/surrender-service/types';
import { useAxios } from 'src/hooks/use-axios';

export function useSurrenderRoot() {
  const surrenderRoot = useAxios(
    (axios, baseConfig) =>
      axios.request<SurrenderRootResponse>({
        ...baseConfig,
        url: PRISMA_CONFIG.surrenderService,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    surrenderRoot.execute();
    // oxlint-disable-next-line exhaustive-deps
  }, []);

  return surrenderRoot;
}

export type SurrenderRootRequest = ReturnType<typeof useSurrenderRoot>;
